import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getLandingSliders = () =>
  axiosInstance.get(`${LANDING_API_URL}/landing-sliders`, {
    headers: authHeaders(),
  });

export const createLandingSliderRequest = (formData) =>
  axiosInstance.post(`${LANDING_API_URL}/landing-sliders`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const updateLandingSliderRequest = (sliderId, formData) =>
  axiosInstance.post(`${LANDING_API_URL}/landing-sliders/${sliderId}`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const removeLandingSlider = (sliderId) =>
  axiosInstance.delete(`${LANDING_API_URL}/landing-sliders/${sliderId}`, {
    headers: authHeaders(),
  });
